export const openSideBarAction = (type, bool) => {
    return{
        type: type,
        bool: bool
    }
}